import { render, staticRenderFns } from "./FormRecord.vue?vue&type=template&id=1f8537c8&scoped=true&"
import script from "./FormRecord.vue?vue&type=script&lang=js&"
export * from "./FormRecord.vue?vue&type=script&lang=js&"
import style0 from "./FormRecord.vue?vue&type=style&index=0&id=1f8537c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8537c8",
  null
  
)

export default component.exports